var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_vm._v(" "+_vm._s(_vm.$ls.Documents_Query_Validity_Heading.replace("{0}", _vm.formatDate(new Date())).replace("{1}", _vm.formatTime(new Date())))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }